import axios from "axios";

const BASE = "/api/CustomPhoneNumberConfirmation";
const COUNTRY_CODE = "964";

export const OTP_LENGTH = 6;
export const OTP_TTL_SECONDS = 120;
export const MIN_PASSWORD_LENGTH = 8;

// Backend expects 10 digits: no "+", no leading 0, no spaces.
export const normalizePhone = (raw) =>
  String(raw ?? "")
    .replace(/\D/g, "")
    .replace(/^0+/, "");

// Maps backend `code` values to existing/new i18n keys. Backend `message`
// is English-only and must not be shown in the UI.
const ERROR_KEYS = {
  PHONE_REQUIRED: "otpErrPhoneRequired",
  INVALID_PHONE_NUMBER: "otpErrInvalidPhone",
  USER_NOT_FOUND: "userDoseNotExist",
  TOO_MANY_ATTEMPTS: "otpErrTooManyAttempts",
  OTP_SEND_FAILED: "otpErrSendFailed",
  OTP_REQUIRED: "otpErrOtpRequired",
  INVALID_OTP: "otpErrInvalidOtp",
  OTP_EXPIRED: "otpErrOtpExpired",
  PASSWORD_MISMATCH: "otpErrPasswordMismatch",
  PASSWORD_TOO_SHORT: "otpErrPasswordTooShort",
};

const SUCCESS_KEYS = {
  OTP_SENT: "otpSent",
  OTP_VALID: "otpValid",
  PASSWORD_UPDATED: "passwordChangedSuccessfully",
};

export const errorKeyFromCode = (code) => ERROR_KEYS[code] || "otpErrGeneric";
export const successKeyFromCode = (code) => SUCCESS_KEYS[code];

const post = async (path, body) => {
  try {
    const { data } = await axios.post(`${BASE}/${path}`, {
      countryCode: COUNTRY_CODE,
      ...body,
    });
    return { ok: true, code: data?.code };
  } catch (e) {
    return { ok: false, code: e?.response?.data?.code };
  }
};

export const requestOtp = (phoneNumber) =>
  post("RequestOtpCodeForResetPassword", { phoneNumber });

export const verifyOtp = (phoneNumber, otpCode) =>
  post("VerifyOtpCode", { phoneNumber, otpCode });

export const resetPassword = (phoneNumber, otpCode, newPassword, confirmNewPassword) =>
  post("VerifyOtpCodeAndResetPassword", {
    phoneNumber,
    otpCode,
    newPassword,
    confirmNewPassword,
  });
